<div class="container-fluid  row_banner pb-5" style="overflow-x: hidden !important;">
    <app-header></app-header>
    <div class="container">
        <div class="row  text-center justify-content-center">
            <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
                <h1 class="w-100 fnt-w600-40 " style="margin-top: 40px;">Article Writing Tool </h1>
                <span class="w-100 d-inline-block main_text mt-40">Compose high-quality, informative articles with ease,
                    designed to engage readers and communicate your message effectively.</span>
            </div>
        </div>
        <div class="custom-card">
            <p class="text-left px-3" id="eFsubText2" [ngStyle]="{'color': color}" *ngIf="eFsubIF "
                style="margin-bottom: -10px;margin-top: -5px;"><i class="fas fa-check-circle" aria-hidden="true"
                    style="margin-right: 3px;"></i>{{eFsubText2}}
            </p>
            <form style="margin-top: 25px;">
                <div>
                    <div class="">
                        <label for="description" class="aiLabel">Topic *</label>
                        <textarea id="form_topic" name="form_topic" class="form-control bd-light" rows="1" spellcheck="false" data-gramm="false"
                            placeholder="Example: The impact of renewable energy on the environment"
                            required></textarea>
                    </div>
                    <div class="mt10">
                        <label for="format" class="aiLabel">Key Points *</label>
                        <textarea id="form_key" name="form_key" class="form-control bd-light" rows="3" spellcheck="false" data-gramm="false"
                            placeholder=" Example: Benefits of renewable energy, reduction in greenhouse gases, economic advantages, and future trends"
                            required></textarea>
                    </div>
                    <div class="mt10">
                        <label for="format" class="aiLabel">Target Audience *</label>
                        <textarea id="form_target" name="form_target" class="form-control bd-light" rows="1" spellcheck="false" data-gramm="false"
                            placeholder="Example: Environmental enthusiasts, policy makers, or general public"
                            required></textarea>
                    </div>
                    <div class="mt10">
                        <label for="format" class="aiLabel">Tone of Writing</label>
                        <textarea id="form_tone" name="form_tone" class="form-control bd-light" rows="1" spellcheck="false" data-gramm="false"
                            placeholder="Example: Informative, Persuasive, or Conversational" required></textarea>
                    </div>

                </div>
                <div class="progress-loader-div">
                    <div class="progress-loader" *ngIf="loaderAlert"></div>
                  </div>
                <div class="input-group-append btn-submit-div ">
                    <button type="submit" class="btn btn-dark m-0 btn-submit " value="Submit"  (click)="eFormSubmission($event)">
                         Submit </button>
                        <button  *ngIf="output_display"   type="submit" class="btn btn-dark m-0  btn-submit"
                        (click)="reFreshWindow()"
                           >
                      Start New Search  </button>
                </div>
            </form>
            <div class="outputDisplay mt-3" *ngIf="output_display"  >
                <div class="outputtop">
               
                        <p class="outputtopTxt">
                            Your article is below
                        </p>
               
                    <div class="outputtopButton tooltipss" (click)="copyToClipboard()" role="button" tabindex="0"
                        (keydown.enter)="copyToClipboard()">
                        <span class="tooltiptext">Copy</span>
                        <span class="tooltiptext" id="copried_txt" *ngIf="copiedtext">Copied</span>
                        <img src="../../assets/images/About us-assets/copy-frame.svg" alt=" copy-frame" height="18px" width="18px">
                        <p class="">Copy to clipboard</p>
                    </div>
                </div>
                <div class="responseD">
                    <div class="responseO" [innerHTML]="output"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<a (click)="scrollToTop()" *ngIf="shouldShowButton" id="scroll-to-top" data-tooltip="Go to top">

  <app-icons-free-tools name="goToTopIcon" />
</a>

<app-footer></app-footer>
